import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Moment } from 'moment';
import moment from 'moment'
import 'moment/locale/pt-br';

export default function BasicDatePicker({
  label,
  value,
  onChange,
  blockFutureDates = false,
  blockPastDates = false,
  error = false,
  helperText = '',
  views = ['year', 'month', 'day'],
  formatString = 'DD/MM/YYYY',
  disabled = false,
  pastDates = moment(),
  futureDates = moment().subtract(1, 'day'),
  sizeInput = 'medium',
  required = false,
  readonly = true
}: BasicDatePickerProps) {
  const yesterday: Moment | undefined = blockFutureDates ? futureDates : undefined
  const today: Moment | undefined = blockPastDates ? pastDates : undefined

  return (
    <DatePicker
      {...{ views }}
      sx={{ width: '100%' }}
      label={label}
      value={value}
      onChange={onChange}
      maxDate={yesterday}
      minDate={today}
      format={formatString}
      disabled={disabled}
      slotProps={{
        textField: {
          error: error,
          size: sizeInput,
          required: required,
          helperText: error ? helperText : "",
          inputProps: {
            readOnly: readonly
          }
        }
      }}
    />
  );
}

interface BasicDatePickerProps {
  label: string;
  value?: Moment | null;
  blockFutureDates?: boolean
  blockPastDates?: boolean
  onChange?: (data: Moment | null) => void;
  views?: Array<"year" | "month" | "day">,
  formatString?: string
  disabled?: boolean
  pastDates?: Moment
  futureDates?: Moment
  error?: boolean,
  helperText?: string,
  sizeInput?: 'small' | 'medium'
  required?: boolean
  readonly?: boolean
}